<template>
  <div class="d-flex flex-column">
    <div class="mb-2">
      {{ mensagem }}
    </div>
    <b-button
      size="sm"
      variant="primary"
      @click="onClick"
    >
      {{ textoBotao }}
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    mensagem: {
      type: String,
      required: true,
    },
    textoBotao: {
      type: String,
      default: 'Tentar novamente',
    },
    onClick: {
      type: Function,
      required: true,
    },
  },
}
</script>
